/**
 * Class description
 *
 * Created: 2017-11-17
 * @author jonas
 */

import {AssetQualityLevel, IResourcesGroupConfig} from "@nolimitcity/slot-game/bin/core/resource/asset/Asset";
import {GameResources} from "@nolimitcity/slot-game/bin/core/resource/GameResources";
import {TextureAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/TextureAsset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/BitmapFontAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/core/resource/asset/assettypes/SpineAsset";

// To extend enum
// declare module "@nolimitcity/slot-game/bin/core/resource/ResourcesGroupName" {
//     export enum ResourcesGroupName {
//         GAME_GROUP = "gamegroup"
//     }
// }

// const temp = ResourcesGroupName as any;
// temp["GAME_GROUP"] = "gamegroup";

export class ImmortalFruitsGameAssets {

    //public static INTRO_BACKGROUND: string = "introBackground";
    public static INTRO_LOGO: string = "introLogo";

    public static NORMAL_REEL_DIVIDER: string = "reelDivider";
    public static REELS_BACKGROUND: string = "reelArea";
    public static NEAR_WIN_REEL_DIVIDER: string = "reelDividerNearWin";

    public static MAIN_GAME_BACKGROUND: string = "mainBackground";


    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [
            {
                name: "fonts",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new BitmapFontAsset("NumbersWinCountUp", "fonts/bitmapfonts/NumbersWinCountUp.fnt"),
                    new BitmapFontAsset("NumbersWheel", "fonts/bitmapfonts/CountUpOutro.fnt"),
                    new BitmapFontAsset("CountUPWheel", "fonts/bitmapfonts/CountUPWheel.fnt"),
                    new BitmapFontAsset("betLineFont", "fonts/bitmapfonts/betLineFont.fnt")
                ]
            },
        ],

        main: [
            {
                name: "main",
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                    new TextureAsset("main1", "sheets/main/main1.json"),
                    new TextureAsset("main2", "sheets/main/main2.json"),
                    ],
                animations: {
                    "reelArea": "ui/reelDividers/reelArea",
                    "betlinesBg": "ui/reelDividers/betlinesBg",
                    "ImmortalfruitsLogo": "ImmortalfruitsLogo",
                    "jackpot25": "ui/25",
                    "wheelShadow": "bonusWheel/Bonus Wheel/wheel shadow",
                    "Frame_light_sweep": "Bigwins Assets/Frame_light sweep/Frame_light sweep_",
                    "Frame_light_loop1": "Bigwins Assets/Frame_light_loop1/Frame_light_loop1_",
                    "Frame_light_loop2": "Bigwins Assets/Frame_light_loop2/Frame_light_loop2_",
                    "Frame_light_loop3": "Bigwins Assets/Frame_light_loop3/Frame_light_loop3_",
                    "starAnim": "Bigwins Assets/star/star_",
                    "side_edge_glow": "Bigwins Assets/right_side_edge_glow",
                    "left_side_edge_glow": "Bigwins Assets/left_side_edge_glow",
                    "symbolBgEffect":"Symbol_BG_Effect/Symbol_bg_effect_",
                    "anticipation":"Anticpation/Anticipation_",
                    "bottomGlow":"bottomGlow",
                    "star":"bonusWheel/Bonus Wheel/star",
                    "bigWinTxt":"bigWin/bigWin1",
                }
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json")
                ],
                animations: {
                    "mainBackground": "mainBackground_sym",
                    "bluePieStroke": "blue/Blue_pie_stroke_",
                    "redPieStroke": "redPie/Red_pie_stroke_",

                }
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json")
                ]
            },
            {
                name: "bonusPng",
                assets: [
                    new TextureAsset("bonusPng0", "sheets/bonusPng/bonusPng0.json"),
                    new TextureAsset("bonusPng1", "sheets/bonusPng/bonusPng1.json"),
                ],
                animations: {
                    "lockLoop": "Same_pie_Hit/pie_lock_loop_Normal/lock_oop_",
                    "samePieLock": "Same_pie_Hit/pie_lock_Normal/Same_pie_lock_",
                    "samePieStroke": "Same_pie_Hit/pie_stroke_half size_Add/Same_pie_stroke_",
                    "lockLoop1": "Same_pie_Hit/Blue_wheel/pie_lock_loop_normal/Blue_pie_lock_loop_",
                    "samePieLock1": "Same_pie_Hit/Blue_wheel/pie_lock_normal/Blue_pie_lock_",

                    "lockLoop2": "Same_pie_Hit/Red_wheel/pie_lock_loop_normal/Red_pie_lock_loop_",
                    "samePieLock2": "Same_pie_Hit/Red_wheel/pie_lock_normal/Red_pie_lock_",

                    "pickedPie": "WW_picked_pie/WW_picked_pie",
                    "pickedPie2": "WW_picked_pie/WW_picked_pie2",

                    "borderWheel1": "borderWheel1",
                    "borderWheel2": "borderWheel2",
                    "borderWheel3": "borderWheel3",
                    "rimWheel": "rimWheel",
                    "wheel1": "wheel1",
                    "wheel3": "wheel3",
                    "wheel2": "wheel2",
                    "bWstrokeHalf": "Level up_assets/BW_stroke_half size",
                    "pointer": "pointer",
                    "center": "center",
                    "LevelUp": "Indicator_LevelUp",
                    "jackpotText":"Jackpot_text/Jackpot_text_",
                    "JackpotStatic":"JackpotStatic",

                }
            },
            {
                name: "bigWin",
                assets: [
                    new TextureAsset("bigWin0", "sheets/bigWin/bigWin0.json"),
                ],
                animations: {
                    "bigWinCoin1": "gem_blue/gem_blue_",
                    "bigWinCoin0": "gem_long/",
                    "bigWinCoin2": "gem_round/gem_round_",
                    "winStar": "star",
                }
            },
            {
                name: "Intro_Outro",
                assets: [
                    new TextureAsset("Intro_Outro0", "sheets/Intro_Outro/Intro_Outro0.json"),
                ],
                animations: {
                    "xWheel_Intro": "Intro/xWheel/xWheel_",
                    "redBannerStart": "Intro/Red banner_start/Red banner_start_",
                    "Outro_loop": "Outro_loop/Outro_loop_",
                    "Outro_start": "Outro_start/Outro_start_",
                    "boxParticles": "box_particles",
                }
            },
            {
                name: "mainHigh",
                assets: [
                    new TextureAsset("mainHigh0", "sheets/mainHigh/mainHigh0.json"),
                ],
                animations: {
                    "jackpot100": "100",
                    "jackpot250": "250",
                    "jackpot2500": "2500",
                    "Invisible_mask": "Invisible_mask",
                }
            },

            {
                name: "bgAnimationsHigh",
                assets: [
                    new TextureAsset("bgAnimationsHigh0", "sheets/bgAnimationsHigh/bgAnimationsHigh0.json"),
                ],
                animations: {
                }
            },
            {
                name: "bonusJpeg",
                assets: [
                    new TextureAsset("bonusJpeg0", "sheets/bonusJpeg/bonusJpeg0.json"),
                    new TextureAsset("bonusJpeg1", "sheets/bonusJpeg/bonusJpeg1.json"),
                    new TextureAsset("bonusJpeg2", "sheets/bonusJpeg/bonusJpeg2.json"),
                    new TextureAsset("bonusJpeg3", "sheets/bonusJpeg/bonusJpeg3.json"),
                    new TextureAsset("bonusJpeg4", "sheets/bonusJpeg/bonusJpeg4.json"),
                    new TextureAsset("bonusJpeg5", "sheets/bonusJpeg/bonusJpeg5.json"),
                    new TextureAsset("bonusJpeg6", "sheets/bonusJpeg/bonusJpeg6.json"),
                ],
                animations: {

                    "redStroke":"Red wheel Stroke_Add/Red wheel Stroke_",
                    "fireWork":"Firework_Add/Firework_",
                    "pointerHighlight": "Pointer_highlight/Pointer_highlight_",
                    "pointerStopAnim": "WW_stop_overlay/WW_stop_overlay_",
                }
            },
            {
                name: "mainJackpt",
                assets: [
                    new TextureAsset("mainJackpt0", "sheets/mainJackpt/mainJackpt0.json"),
                ],
                animations: {

                }
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset("mini_jackpot_hit", "Spine/mini_jackpot_hit.json"),
                    new SpineAsset("mini_jackpot_hit_new", "Spine/mini_jackpot_hit_new.json"),
                    new SpineAsset("jackpotMeter", "Spine/jackpot_meter.json"),
                    new SpineAsset("BonusWheelOverlay", "Spine/BonusWheel_overlay.json"),
                    new SpineAsset("Bigwins", "Spine/Bigwins.json"),
                    new SpineAsset("bg_animation", "Spine/bg_animation.json"),
                    new SpineAsset("S_spine", "Spine/Bonus_symbol.json"),
                    new SpineAsset("gameLogo", "Spine/Logo.json"),
                    new SpineAsset("leverYank", "Spine/lever_yank.json"),
                    new SpineAsset("bg_lines", "Spine/bg_lines.json"),
                    new SpineAsset("jackpot_bar", "Spine/jackpot_bar.json"),
                    new SpineAsset("Levelup", "Spine/Levelup.json"),
                    new SpineAsset("intro", "Spine/intro.json"),
                    new SpineAsset("outro", "Spine/outro.json"),
                ]
            }
        ]
    };

    public static getSymbolStateTexturePath(symbolName: string, stateName: string | null = null): string {
        if (stateName === null || stateName === "normal") {
            return symbolName + "/" + symbolName;
        }
        if (stateName == null || stateName == "Land" && symbolName=="W") {
            return symbolName + "/" + symbolName+ "_" + stateName+"/"+"wild_landing_";
        }
        return symbolName + "/" + symbolName + "_" + stateName;
    }

    public static getSymbolStateTextures(symbolName: string, stateName: string | null = null): PIXI.Texture[] {
        return GameResources.getTextures(ImmortalFruitsGameAssets.getSymbolStateTexturePath(symbolName, stateName));
    }
    public static getSymbolWinStateTexture(symbolName: string): PIXI.Texture[] {
            return GameResources.getTextures("W/W_idle/wild_idle_");

    }

    public static getSymbolLandingStateTexture(symbolName:string,statekey:string):PIXI.Texture[] {
            return GameResources.getTextures("W/W_land/wild_landing_");

    }
}
